var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F7FC",
    d: "M12.959 1.66a.758.758 0 0 0-.931 0L1.25 10.064l.932 1.179L3.5 10.215V19.5A1.503 1.503 0 0 0 5 21h15a1.503 1.503 0 0 0 1.5-1.5v-9.278l1.318 1.028.932-1.18-10.791-8.41ZM14 19.5h-3v-6h3v6Zm1.5 0v-6A1.502 1.502 0 0 0 14 12h-3a1.502 1.502 0 0 0-1.5 1.5v6H5V9.046l7.5-5.842 7.5 5.85V19.5h-4.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveHomeIcon);
export default __webpack_public_path__ + "static/media/activeHomeIcon.9c008b95d85b1f2012e2044728b0c806.svg";
export { ForwardRef as ReactComponent };